// localStorage: non-sensitive preferences and flags only, never form data.
export const LOCAL_KEYS = {
	THEME: 'theme',
	LANGUAGE: 'language',
	FONT_SCALE: 'fontScale',
	CONSENT: 'hasConsented',
}

// Interface preferences that survive the wipe after the PDF download.
export const PERSISTENT_PREFERENCE_KEYS = [
	LOCAL_KEYS.THEME,
	LOCAL_KEYS.LANGUAGE,
	LOCAL_KEYS.FONT_SCALE,
]

// sessionStorage: the form itself (cleared when the tab closes).
export const SESSION_KEYS = {
	FORM_DATA: 'appFormData',
	STEP: 'currentStep',
}
